"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/Toolbar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);








var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Popover = require('web/components/Popover'); var _Popover2 = _interopRequireDefault(_Popover);
var _Checkbox = require('web/screens/Broadcast/CampaignPage/Body/MessagesTable/components/Checkbox'); var _Checkbox2 = _interopRequireDefault(_Checkbox);
var _Table = require('./Table');

var _format = require('./format');






























const VIEWS = [
  { value: 'active', label: 'Active', icon: 'active' },
  { value: 'archived', label: 'Archived', icon: 'completed' },
]

const TEXTING_FILTERS = ['deliverable', 'opted_out', 'blocked', 'cant_receive']
const APP_USE_FILTERS = ['app_user', 'not_app_user']

// A date field's day as the start of that day (From) or of the next (To,
// which the server treats as exclusive), in the viewer's time zone.
const dayToISO = (day, isEnd) => {
  if (!day) return undefined
  const at = _moment2.default.call(void 0, day, 'YYYY-MM-DD').startOf('day')
  return (isEnd ? at.add(1, 'day') : at).toISOString()
}
const isoToDay = (iso, isEnd) => {
  if (!iso) return ''
  const at = _moment2.default.call(void 0, iso)
  return (isEnd ? at.subtract(1, 'day') : at).format('YYYY-MM-DD')
}

const filterCount = (f) => [
  (_nullishCoalesce(_optionalChain([f, 'access', _ => _.TagKeys, 'optionalAccess', _2 => _2.length]), () => ( 0))) > 0,
  !!(f.CreatedFrom || f.CreatedTo),
  !!(f.LastActivityFrom || f.LastActivityTo),
  (_nullishCoalesce(_optionalChain([f, 'access', _3 => _3.Texting, 'optionalAccess', _4 => _4.length]), () => ( 0))) > 0,
  (_nullishCoalesce(_optionalChain([f, 'access', _5 => _5.AppUse, 'optionalAccess', _6 => _6.length]), () => ( 0))) > 0,
].filter(Boolean).length

const toggleIn = (list, value) => {
  const next = (_nullishCoalesce(list, () => ( []))).filter(v => v !== value)
  return next.length === (_nullishCoalesce(list, () => ( []))).length ? [...next, value] : next
}

const DateRange




 = ({ label, from, to, onChange }) => (
  _react2.default.createElement('fieldset', { className: "dir-filters--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
    , _react2.default.createElement('legend', { className: "dir-filters--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}},  label )
    , _react2.default.createElement('div', { className: "dir-filters--dates", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
      , _react2.default.createElement('input', {
        type: "date",
        className: "blm-text-input",
        'aria-label': `${label} from`,
        value: isoToDay(from, false),
        onChange: e => onChange(dayToISO(e.target.value, false), to), __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
      )
      , _react2.default.createElement('span', { className: "dir-filters--to", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}, "to")
      , _react2.default.createElement('input', {
        type: "date",
        className: "blm-text-input",
        'aria-label': `${label} to`,
        value: isoToDay(to, true),
        onChange: e => onChange(from, dayToISO(e.target.value, true)), __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
      )
    )
  )
)

/* The Filters panel: tags (any of them), created date, last activity (the
 * later of the two message dates) and texting status (D-6). Built from the
 * app's popover, checkboxes and date fields: no round-3 frame draws it. Each
 * tag shows how many active patients in the org have it, right-aligned; one
 * with none is greyed but can still be ticked (D-84, x-pk5, x-pt5). */
/* hasPatientApp: the org keeps "Patients can use the app" on. While it is
 * off the "Patient app" group is hidden (and usePatientTable drops its ticks). */
 const FiltersPanel




 = ({ filter, onFilter, tags, hasPatientApp = false }) => (
  _react2.default.createElement('div', { className: "dir-filters", role: "group", 'aria-label': "Filters", __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}
    , _react2.default.createElement('fieldset', { className: "dir-filters--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
      , _react2.default.createElement('legend', { className: "dir-filters--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}, "Tags")
      ,  tags.length === 0 && _react2.default.createElement('span', { className: "dir-cell--quiet", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}, "No tags yet"  ) 
      , _react2.default.createElement('div', { className: "dir-filters--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}
        ,  tags.map(tag => (
          _react2.default.createElement('div', { key: tag.TagKey, className: "dir-filters--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
            , _react2.default.createElement(_Checkbox2.default, {
              isChecked: !!_optionalChain([filter, 'access', _7 => _7.TagKeys, 'optionalAccess', _8 => _8.includes, 'call', _9 => _9(tag.TagKey)]),
              label: tag.Name,
              onChange: () => onFilter({ ...filter, TagKeys: toggleIn(filter.TagKeys, tag.TagKey) }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}
            )
            , _react2.default.createElement('button', {
              type: "button",
              className: _classBuilder2.default.call(void 0, 'dir-filters--name', tag.Patients === 0 && 'dir-filters--name-none'),
              title: tag.Name,
              onClick: () => onFilter({ ...filter, TagKeys: toggleIn(filter.TagKeys, tag.TagKey) }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}

              ,  tag.Name 
            )
            ,  tag.Patients !== undefined && (
              _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'dir-filters--count', tag.Patients === 0 && 'dir-filters--name-none'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}},  _format.formatCount.call(void 0, tag.Patients) )
            )
          )
        ))
      )
    )
    , _react2.default.createElement(DateRange, {
      label: "Created",
      from: filter.CreatedFrom,
      to: filter.CreatedTo,
      onChange: (CreatedFrom, CreatedTo) => onFilter({ ...filter, CreatedFrom, CreatedTo }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
    )
    , _react2.default.createElement(DateRange, {
      label: "Last activity" ,
      from: filter.LastActivityFrom,
      to: filter.LastActivityTo,
      onChange: (LastActivityFrom, LastActivityTo) => onFilter({ ...filter, LastActivityFrom, LastActivityTo }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}
    )
    , _react2.default.createElement('fieldset', { className: "dir-filters--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}
      , _react2.default.createElement('legend', { className: "dir-filters--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}, "Texting")
      , _react2.default.createElement('div', { className: "dir-filters--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}}
        ,  TEXTING_FILTERS.map(status => (
          _react2.default.createElement('div', { key: status, className: "dir-filters--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}
            , _react2.default.createElement(_Checkbox2.default, {
              isChecked: !!_optionalChain([filter, 'access', _10 => _10.Texting, 'optionalAccess', _11 => _11.includes, 'call', _12 => _12(status)]),
              label: _format.TEXTING_LABELS[status],
              onChange: () => onFilter({ ...filter, Texting: toggleIn(filter.Texting, status) }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}}
            )
            , _react2.default.createElement('button', { type: "button", className: "dir-filters--name", onClick: () => onFilter({ ...filter, Texting: toggleIn(filter.Texting, status) }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}},  _format.TEXTING_LABELS[status] )
          )
        ))
      )
    )
    ,  hasPatientApp && (
      _react2.default.createElement('fieldset', { className: "dir-filters--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}}
        , _react2.default.createElement('legend', { className: "dir-filters--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}, "Patient app" )
        , _react2.default.createElement('div', { className: "dir-filters--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}
          ,  APP_USE_FILTERS.map(use => (
            _react2.default.createElement('div', { key: use, className: "dir-filters--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}
              , _react2.default.createElement(_Checkbox2.default, {
                isChecked: !!_optionalChain([filter, 'access', _13 => _13.AppUse, 'optionalAccess', _14 => _14.includes, 'call', _15 => _15(use)]),
                label: _format.APP_USE_LABELS[use],
                onChange: () => onFilter({ ...filter, AppUse: toggleIn(filter.AppUse, use) }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}
              )
              , _react2.default.createElement('button', { type: "button", className: "dir-filters--name", onClick: () => onFilter({ ...filter, AppUse: toggleIn(filter.AppUse, use) }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}},  _format.APP_USE_LABELS[use] )
            )
          ))
        )
      )
    )
    ,  _format.hasFilters.call(void 0, filter) && (
      _react2.default.createElement('button', { type: "button", className: "dir-link dir-filters--clear" , onClick: () => onFilter({}), __self: this, __source: {fileName: _jsxFileName, lineNumber: 195}}, "Clear filters" )
    )
  )
); exports.FiltersPanel = FiltersPanel

const Toolbar = ({
  view, onView, activeCount, archivedCount, search, onSearch, filter, onFilter, tags,
  hiddenColumns, onToggleColumn, hasCounts, onOpenFilters, isSearchOnly = false, beforeFilters, afterFilters,
  hasPatientApp = false,
}) => {
  const filtersRef = _react.useRef(null)
  const columnsRef = _react.useRef(null)
  const [open, setOpen] = _react.useState(null)
  const counts = { active: activeCount, archived: archivedCount }
  const activeFilters = filterCount(filter)
  return (
    _react2.default.createElement('div', { className: "recipients-toolbar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}
      ,  !isSearchOnly && (
      _react2.default.createElement('div', { role: "tablist", className: "dir-toolbar--state", __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}}
        ,  VIEWS.map(v => {
          const isSelected = v.value === view
          return (
            _react2.default.createElement('div', {
              key: v.value,
              role: "tab",
              tabIndex: 0,
              'aria-selected': isSelected,
              className: _classBuilder2.default.call(void 0, 'filter-tabs--item', isSelected && 'selected'),
              onClick: () => onView(v.value),
              onKeyDown: e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  onView(v.value)
                }
              }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}

              , _react2.default.createElement('img', { alt: "", src: `/assets/icons/tabs/${v.icon}-${isSelected ? 'purple' : 'grey'}.svg`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}} )
              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 232}},  v.label ,  hasCounts && _react2.default.createElement('span', { className: "dir-count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}},  _format.formatCount.call(void 0, counts[v.value]) ) )
            )
          )
        })
      )
      )
      , _react2.default.createElement('label', { className: "recipients-toolbar--search", __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}}
        , _react2.default.createElement('img', { alt: "", className: "recipients-toolbar--search-icon", src: "/assets/icons/search-grey.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}} )
        , _react2.default.createElement('input', {
          'aria-label': view === 'archived' ? 'Search archived patients' : 'Search patients',
          placeholder: view === 'archived'
            ? 'Search archived patients by name, phone, email or MRN'
            : 'Search by name, phone, email or MRN',
          type: "search",
          value: search,
          onChange: e => onSearch(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}}
        )
      )
      ,  beforeFilters 
      , _react2.default.createElement('button', {
        ref: filtersRef,
        type: "button",
        className: "blm-btn blm-btn--secondary dir-toolbar--btn dir-toolbar--filters"   ,
        'aria-expanded': open === 'filters',
        onClick: () => {
          if (open !== 'filters') onOpenFilters()
          setOpen(open === 'filters' ? null : 'filters')
        }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}

        , _react2.default.createElement('img', { alt: "", src: "/assets/icons/video/filter-black.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 261}} ), "Filters"

        ,  activeFilters > 0 && _react2.default.createElement('span', { className: "dir-count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 263}},  activeFilters ) 
        , _react2.default.createElement('span', { className: "dir-toolbar--caret", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}, "▾")
      )
      ,  afterFilters 
      ,  !isSearchOnly && (
      _react2.default.createElement('button', {
        ref: columnsRef,
        type: "button",
        className: "blm-btn blm-btn--secondary dir-toolbar--btn"  ,
        'aria-expanded': open === 'columns',
        onClick: () => setOpen(o => o === 'columns' ? null : 'columns'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}}
, "Columns"
        , _react2.default.createElement('span', { className: "dir-toolbar--caret", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}, "▾")
      )
      )
      ,  open === 'filters' && (
        _react2.default.createElement(_Popover2.default, { anchorRef: filtersRef, align: "right", onClose: () => setOpen(null), className: "dir-popover", __self: this, __source: {fileName: _jsxFileName, lineNumber: 279}}
          , _react2.default.createElement(exports.FiltersPanel, { filter: filter, onFilter: onFilter, tags: tags, hasPatientApp: hasPatientApp, __self: this, __source: {fileName: _jsxFileName, lineNumber: 280}} )
        )
      )
      ,  open === 'columns' && (
        _react2.default.createElement(_Popover2.default, { anchorRef: columnsRef, align: "right", onClose: () => setOpen(null), className: "dir-popover", __self: this, __source: {fileName: _jsxFileName, lineNumber: 284}}
          , _react2.default.createElement('div', { className: "dir-filters", role: "group", 'aria-label': "Columns", __self: this, __source: {fileName: _jsxFileName, lineNumber: 285}}
            , _react2.default.createElement('div', { className: "dir-filters--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 286}}
              ,  _Table.COLUMNS[view].map(c => (
                _react2.default.createElement('div', { key: c.id, className: "dir-filters--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 288}}
                  , _react2.default.createElement(_Checkbox2.default, { isChecked: !hiddenColumns.has(c.id), label: `Show ${c.label}`, onChange: () => onToggleColumn(c.id), __self: this, __source: {fileName: _jsxFileName, lineNumber: 289}} )
                  , _react2.default.createElement('button', { type: "button", className: "dir-filters--name", onClick: () => onToggleColumn(c.id), __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}},  c.label )
                )
              ))
            )
          )
        )
      )
    )
  )
}

exports. default = Toolbar
